(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ControllerDialogController', ControllerDialogController);

    ControllerDialogController.$inject = ['$scope','$timeout','$stateParams','$uibModalInstance','$q','entity','Controller','ControllerCustomService','ToastrService','DateUtils',
                                        'ShipmentCustomService', 'InvoiceCustomService','ControllerPayment','ControllerPaymentCustomService'];

    function ControllerDialogController($scope, $timeout, $stateParams, $uibModalInstance, $q, entity, Controller, ControllerCustomService, ToastrService, DateUtils,
                                        ShipmentCustomService, InvoiceCustomService, ControllerPayment, ControllerPaymentCustomService) {

        var vm = this;

        vm.controller = entity;
        vm.currencyTypes = ['USD','EUR'];
        vm.shipments = [];
        vm.invoices = [];
        vm.controllerPayments = [];
        vm.paymentsTotal = 0;
        vm.controllersByDate = ['WIS','WIS','SGS','Cargo Control','Interek','WIS','WIS'];

        initCpNew();

        if(vm.controller.id === null) {
            checkCurrentDate();
        }

        vm.clear = clear;
        vm.save = save;
        vm.fetchShipments = fetchShipments;
        vm.fetchInvoices = fetchInvoices;
        vm.onTextClick = onTextClick;
        vm.updateAmountDisplay = updateAmountDisplay;
        vm.activateCurrencyType = activateCurrencyType;
        vm.updateBalance = updateBalance;
        vm.addPayment = addPayment;
        vm.updatePayment = updatePayment;
        vm.editPayment = editPayment;
        vm.initCpNew = initCpNew;
        vm.getControllerPayments = getControllerPayments;
        vm.removePayment = removePayment;
        vm.openCalendar = openCalendar;
        vm.updateCpAmountDisplay = updateCpAmountDisplay;

        vm.datePickerOpenStatus = {
            paymentDate: false
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        fetchShipments();
        fetchInvoices();
        getControllerPayments();

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if(vm.controller.id !== null) {
                Controller.update(vm.controller, onSaveSuccess, onSaveError);
            } else {
                Controller.save(vm.controller, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            var newController = vm.controller.id === null;
            vm.controller.id = result.id;
            if(newController) {
                var promlist = [];
                if(vm.controllerPayments.length > 0) {
                    for(var i=0; i < vm.controllerPayments.length; i++) {
                        vm.controllerPayments[i].controller = result;
                        if(vm.controllerPayments[i].id !== null) {
                            promlist.push(ControllerPayment.update(vm.controllerPayments[i]).$promise);
                        } else {
                            promlist.push(ControllerPayment.save(vm.controllerPayments[i]).$promise);
                        }
                    }
                }
                if(promlist.length > 0) {
                    $q.all(promlist).then(function() {
                        finalizeSave(result);
                    }).then(function() {
                        finalizeSave(result);
                    });
                } else {
                    finalizeSave(result);
                }
            } else {
                finalizeSave(result);
            }
        }

        function finalizeSave(result) {
            vm.isSaving = false;
            $scope.$emit('ccsTrApp:controllerUpdate', result);
            ToastrService.success("Successfully saved Controller Payment", "Success!");
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            ToastrService.error("Something went wrong", "Error");
            vm.isSaving = false;
        }

        function fetchShipments() {
            vm.shipments = [];
            ShipmentCustomService.findAllNotCancelledShipmentsForController().then(function(data) {
                vm.shipments = data.data;
            }, function(error) {
                ToastrService.error("Failed to fetch Shipments", "Error!");
            });
        }

        function fetchInvoices() {
            if(vm.controller.shipment !== null) {
                vm.invoices = [];
                InvoiceCustomService.findAllInvoicesByShipmentIdForController(vm.controller.shipment.id).then(function(data) {
                    vm.invoices = data.data;
                    if(vm.invoices.length === 0) {
                        ToastrService.info("No Invoices related to selected Shipment", "Info");
                    }
                }, function(error) {
                    ToastrService.error("Failed to fetch Invoices", "Error!");
                });
            }
        }

        function updateAmountDisplay() {
            vm.controller.amountDisplay = vm.controller.currency + " " + vm.controller.amount;
        }

        function activateCurrencyType(type) {
            vm.controller.currency = type;
            updateAmountDisplay();
        }

        function getControllerPayments() {
            if(vm.controller.id !== null) {
                vm.controllerPayments = [];
                ControllerPaymentCustomService.findAllControllerPaymentsByControllerId(vm.controller.id).then(function(data) {
                    vm.controllerPayments = data.data;
                    updateBalance();
                    vm.paymentsTotal = getControllerPaymentSum();
                    if(vm.controllerPayments.length === 0) {
                        ToastrService.info("No Payments under this Controller", "Info");
                    }
                }, function(error) {
                    ToastrService.error("Failed to get Controller Payments", "Error");
                });
            }
        }

        function getControllerPaymentSum() {
            var sum = 0;
            if(vm.controllerPayments.length > 0) {
                angular.forEach(vm.controllerPayments, function(value, key) {
                   sum += value.amount;
                });
            }
            return setScale(sum, 2);
        }

        function updateBalance() {
            var balance = vm.controller.amount;
            vm.paymentsTotal = getControllerPaymentSum();
            balance = balance - vm.paymentsTotal;
            vm.controller.balance = balance;
        }

        function initCpNew() {
            vm.cpNew = {
                id: null,
                createdOn: new Date(),
                createdBy: "admin",
                modifiedOn: new Date(),
                modifiedBy: "admin",
                paymentLabel: null,
                paymentDate: new Date(),
                amount: 0,
                currency: vm.controller.currency,
                amountDisplay: vm.controller.currency + " " + 0
            }
        }

        function updateCpAmountDisplay() {
            vm.cpNew.amountDisplay = vm.controller.currency + " " + vm.cpNew.amount;
        }

        function addPayment() {
            vm.cpNew.currency = vm.controller.currency;
            updateCpAmountDisplay();
            if(vm.controller.id !== null) {
                vm.cpNew.controller = vm.controller;
                ControllerPayment.save(vm.cpNew, function() {
                    getControllerPayments();
                    initCpNew();
                }, function() {
                    ToastrService.error("Failed to save Controller Payment", "Error");
                })
            } else {
                vm.controllerPayments.push(vm.cpNew);
                updateBalance();
                initCpNew();
            }
        }

        function updatePayment() {
            vm.cpNew.currency = vm.controller.currency;
            updateCpAmountDisplay();
            vm.cpNew.controller = vm.controller;
            ControllerPayment.update(vm.cpNew, function() {
                getControllerPayments();
                initCpNew();
            }, function(error) {
                ToastrService.error("Failed to update Controller Payment","Error");
            })
        }

        function editPayment(cp) {
            vm.cpNew = cp;
            vm.cpNew.paymentDate = DateUtils.convertLocalDateFromServer(cp.paymentDate);
        }

        function removePayment(cp) {
            if(cp.id !== null) {
                ControllerPayment.delete(cp, function() {
                    getControllerPayments();
                }, function() {
                    ToastrService.error("Failed to delete Controller Payment", "Error");
                });
            } else {
                var index = vm.controllerPayments.indexOf(cp);
                vm.controllerPayments.splice(index);
                updateBalance();
            }
        }

        function setScale(value, scale) {
            return parseFloat(value).toFixed(scale);
        }

        function onTextClick($event) {
            $event.target.select();
        }

        function checkCurrentDate() {
            var dd = new Date().getDay();
            vm.controller.controller = vm.controllersByDate[dd];
        }

    }
})();
